import React,{Component} from 'react';
import {Modal,Button,Row,Col,Form} from 'react-bootstrap';
import axios from 'axios';

export  class AddTopicsModal extends Component{
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            TopicList:[]
            
        }
      

    }
    componentDidMount() {
        
        this.getTopicsList();
    }  
    
    getTopicsList() {
        fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTopic/Get").then(response => response.json())
        .then(res=> {            
          this.setState ( { TopicList: res} )
            })
            .catch(err => {
              console.log(err);
          }) 
          console.log(this.state.TopicList);
      }
    
    getdomain() {
        fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/Domains/"+2).then(response => response.json())
        .then(res=> {            
          this.setState ( { DomainList: res } )
            })
            .catch(err => {
              console.log(err);
          }) 
      }
      
    handleSubmit(event){
        event.preventDefault();
        const options = {
            headers: {"content-type": "text/plain"}
        }
    const article = {taskid:this.props.TaskId, topicid:0, phase:event.target.Phase.value,
        usecase:event.target.usecase.value,
        topic:event.target.topic.value,description:event.target.description.value,uniqueIdentifier:event.target.uniqueidentifier.value,username:this.props.username  };
    axios.post('https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTopic/Post', article,options)
        .then((result)=> {            
            alert("Data saved successfully");
            this.props.filterchangetest(this.props.servicegroup,this.props.scope,this.props.level,this.props.TaskId);

             },
             (error) => {
                 alert("Data failed to save");
           }) 
           
          
          

    }

    render(){
        return (
            <div className='container'>
            <Modal  {...this.props} size='lg'  aria-labelledby='contained-modal-title-vcenter' centered >
                <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Add Topic
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                          <Form onSubmit={this.handleSubmit}>
                          <Form.Group controlId='topics'>
                             
                             
                           
                              <div class="col-md-6">
                              <Form.Label>KT Phase*</Form.Label>
                              <Form.Select className='form-control' style={{width:275}} name='Phase'  required>
                                  <option>Select</option>
                                  <option>Foundation Learning</option>
                                  <option>Discover & Simulate</option>
                                  <option>Demonstrate</option>
                              </Form.Select>
                              </div>
                              <div class="col-md-6">
                              <Form.Label>Topic*</Form.Label>
                              <Form.Control as="textarea" maxLength={3000} rows="2" style={{width:275}} name='topic' required ></Form.Control>
                             
                              </div>
                              <div class="col-md-6">
                              <Form.Label>UseCase*</Form.Label>
                              <Form.Control as="textarea" maxLength={200} rows="2" style={{width:275}} name='usecase' required ></Form.Control>

                              </div>
                              <div class="col-md-6">
                              <Form.Label>Topic Description*</Form.Label>
                              <Form.Control as="textarea" maxLength={5000} rows="2" style={{width:275}} name='description' required ></Form.Control>
                            
                              
                              </div>
                              <div class="col-md-6">
                              <Form.Label>unique Identifier*</Form.Label>
                              <Form.Control type='text' maxLength={10} style={{width:275}} name='uniqueidentifier' required ></Form.Control>
                            
                              
                              </div>
                              
                              
                          </Form.Group>  
                          <Form.Group className='col-md-12'>
                              <Button variant='primary' style={{margin:10}} className='btn-new btn-confirm' type='submit'>
                                  Save
                              </Button> 
                              <Button onClick={this.props.onHide} style={{margin:10,backgroundColor:'gray'}} className='btn-new btn-confirm' >Close
                              </Button> 
                          </Form.Group>  
                          </Form>  
                        </Col>
                    </Row>
                </Modal.Body>
               
            </Modal>
            </div>
        )
    }
}